import React from 'react';

import { SafeHtml } from '@/components/SafeHtml';
import { cn } from '@/utils/styles.utils';

interface Props {
  content: string;
  side?: 'left' | 'right';
}

export const StaticContentText = (props: Props) => {
  const { content, side } = props;

  return (
    <div
      className={cn({
        'laptop:pr-[16%]': side === 'left',
        'laptop:pl-[16%]': side === 'right',
      })}
    >
      <SafeHtml content={content} />
    </div>
  );
};
